import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Link, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { json, useNavigate } from "react-router-dom";
import usePersistedFilters from "../../edvenswa.emportal.common/hooks/usePersistedFilters";
import GenericTable from "../../edvenswa.emportal.common/pages/GenericTable";
import { axiosInstance } from "../../../interceptors/AxiosInterceptor";
// import GenerateReport from "./GenerateReport";
import VisibilityIcon from "@mui/icons-material/Visibility";
import "jspdf-autotable";
import moment from "moment";
import { utils, write } from "xlsx";
import * as XLSXStyle from "xlsx-js-style";
import { exportBiWeeklyRatingsExcel } from '../../edvenswa.emportal.common/utils/biWeeklyExcelExport';
import saveAs from "file-saver";
import jsPDF from "jspdf";
import PastRatingsCustomCell from "../../edvenswa.emportal.reports/pages/PastRatingsCustomCell";

const ProjectManagerAppraisal = (props) => {
  const { onError, setLoad, user } = props;
  const navigate = useNavigate();
  const [users, setusers] = useState([]);
  const [filteredusers, setFilteredusers] = useState([]);

  const [username, setusername] = useState("");
  const [userTasks, setUserTasks] = useState([]);
  const [project, setProject] = useState("All");
  const [datefilter, setDateFilter] = useState("Last Bi-Weekly");
  const [page, setPage] = useState(1);
  const [associateStatus, setAssociateStatus] = useState("ACTIVE");
  const sortBy = associateStatus;
  const pageSize = 5;
  const totalPages = 0;
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [aiDialog, setAiDialog] = useState({ open: false, data: null, name: "" });
  const role = user.roles[0];
  const type = "Appraisals";
  const [startDateError, setStartDateError] = useState("");
  const [endDateError, setEndDateError] = useState("");
  const [pastRatings, setPastRatings] = useState({});
  const defaultStartDate = moment(new Date()).format("DD") > 15
    ? moment(new Date()).startOf("month").add(15, "day").format("YYYY-MM-DD")
    : moment(new Date()).startOf("month").format("YYYY-MM-DD");
  const defaultEndDate = moment(new Date()).format("DD") > 15
    ? moment(new Date()).endOf("month").format("YYYY-MM-DD")
    : moment(new Date()).startOf("month").add(14, "days").format("YYYY-MM-DD");
  const [filters, setFilter] = usePersistedFilters("pmappraisal_filters", {
    searchTerm: "",
    startDate: defaultStartDate,
    endDate: defaultEndDate,
    tenantId: user.tenantId,
  });
  const { searchTerm, startDate, endDate, tenantId } = filters;
  const setSearchTerm = (val) => setFilter("searchTerm", val);
  const setStartDate = (val) => setFilter("startDate", val);
  const setEndDate = (val) => setFilter("endDate", val);
  const setTenantId = (val) => setFilter("tenantId", val);

  const endDateRef = useRef(endDate);
  useEffect(() => { endDateRef.current = endDate; }, [endDate]);

  const [projectFromAppraisal, setProjectFromAppraisal] = useState("All");
  const [ratingsEndDate, setRatingsEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [currentDateFilter, setCurrentDateFilter] = useState("Last Bi-Weekly");

 useEffect(() => {
  const refreshSubmissionStatus = () => {
    if (document.visibilityState === "visible") {
      const isValidDate = (d) => d && /^\d{4}-\d{2}-\d{2}$/.test(d) && !isNaN(new Date(d).getTime());
      if (!isValidDate(startDate) || !isValidDate(endDate)) return;
      axiosInstance
        .post(
          `/user/getAllassociatesforRatings?project=${projectFromAppraisal}&sortBy=${sortBy}&tenantId=${tenantId}`,
          { startDate, endDate }
        )
        .then((res) => {
          const astIds = res?.data.map((u) => u?.associateId);
          const requestedEndDate = endDate;
          if (astIds.length > 0) {
            axiosInstance
              .put(`/user/get/past/ratings?endDate=${requestedEndDate}&managerId=${user.associateId}`, astIds)
              .then((r) => {
                if (requestedEndDate === endDateRef.current) setPastRatings(r?.data);
              })
              .catch((err) => console.log(err));
          }
        })
        .catch((err) => console.log(err));
    }
  };

  document.addEventListener("visibilitychange", refreshSubmissionStatus);

  return () => {
    document.removeEventListener("visibilitychange", refreshSubmissionStatus);
  };
}, [startDate, endDate, projectFromAppraisal, sortBy, tenantId]);



  useEffect(() => {
    const isValidDate = (d) => d && /^\d{4}-\d{2}-\d{2}$/.test(d) && !isNaN(new Date(d).getTime());
    if (!isValidDate(startDate) || !isValidDate(endDate)) return;
    if (startDate > endDate) return;

    setLoading(true);
    let userArr = [];
    let newObj = {};
    for (let i = 0; i < arr.length; i++) {
      if (i % 2 == 0) {
        newObj = { ...newObj, [arr[i].concat(" - ").concat(arr[i + 1])]: 0 };
      }
    }
    axiosInstance
      .post(
        `/user/getAllassociatesforRatings?project=${projectFromAppraisal}&sortBy=${sortBy}&tenantId=${tenantId}`,
        { startDate: startDate, endDate: endDate }
      )
      .then((res) => {
        res.data.map((data) => {
          let userObj = {};
          let comment = "";
          if (data.userAppraisalsList.length !== 0) {
            let changedNewObj = { ...newObj };
            data.userAppraisalsList.map((appraisal) => {
              comment = appraisal?.comments;
              Object.keys(newObj).map((key) => {
                if (
                  key ===
                  moment(appraisal?.startDate, "YYYY,MM,DD")
                    .format("DD/MMM")
                    .concat(" - ")
                    .concat(
                      moment(appraisal?.endDate, "YYYY,MM,DD").format(
                        "DD/MMM/YYYY"
                      )
                    )
                ) {
                  changedNewObj[key] = parseFloat(
                    appraisal?.ratings.toFixed(2)
                  );
                }
              });
            });
            userObj = { ...data, ...changedNewObj, Comments: comment };
          } else {
            userObj = { ...data, ...newObj };
          }
          userArr.push(userObj);
        });
        setusers(userArr);
        const astIds = res?.data.map((user) => user?.associateId);
        const requestedEndDate = endDate;
        if (astIds.length > 0) {
          axiosInstance
            .put(`/user/get/past/ratings?endDate=${requestedEndDate}&managerId=${user.associateId}`, astIds)
            .then((res) => {
              if (requestedEndDate === endDateRef.current) setPastRatings(res?.data);
            })
            .catch((err) => console.log(err));
        }
        setLoading(false);
      });
  }, [startDate, endDate, projectFromAppraisal, associateStatus]);

  // Apply search filter client-side whenever searchTerm or the base users list changes
  useEffect(() => {
    if (searchTerm.length > 0) {
      const searchedUsers = users.filter(
        (data) =>
          data["firstname"].toLowerCase().includes(searchTerm) ||
          data["lastname"].toLowerCase().includes(searchTerm) ||
          `${data.associateId}`.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredusers(searchedUsers);
    } else {
      setFilteredusers(users);
    }
  }, [searchTerm, users]);

  let arr = [];
  if (
    (moment(startDate).format("DD") === "01" ||
      moment(startDate).format("DD") === "16") &&
    (moment(endDate).format("DD") === "15" ||
      moment(endDate).format("DD") === moment(endDate).daysInMonth().toString())
  ) {
    let count = 1;
    for (
      let i = moment(startDate);
      moment(i).isSameOrBefore(endDate);
      i = moment(i).add(1, "day")
    ) {
      if (
        moment(i).format("DD") === "01" ||
        moment(i).format("DD") === "15" ||
        moment(i).format("DD") === "16" ||
        moment(i).format("DD") === moment(i).daysInMonth().toString()
      ) {
        count++;
        if (count % 2 == 0) {
          arr.push(moment(i).format("DD/MMM"));
        } else {
          arr.push(moment(i).format("DD/MMM/YYYY"));
        }
      }
    }
  } else {
    console.log(
      "select dates correctly... startdate should start of month and enddate should be end of month "
    );
  }

  function formatDate(dateString) {
    const options = { month: "short", day: "2-digit" };
    const date = new Date(dateString);

    const formattedDate = date.toLocaleDateString("en-GB", options); // Output will be "16 Apr"

    // Replace the space with a slash to get "16/Apr"
    const dateWithSlash = formattedDate.replace(" ", "/");

    return dateWithSlash;
  }
  function formatEndDate(dateString) {
    const options = { month: "short", day: "2-digit", year: "numeric" };
    const date = new Date(dateString);

    // This gives "16 Apr 2025"
    const formattedDate = date.toLocaleDateString("en-GB", options);

    // Replace spaces with slashes: "16/Apr/2025"
    const dateWithSlashes = formattedDate.replace(/ /g, "/");

    return dateWithSlashes;
  }

  const CustomNameComponent = (row) => {
    const key = `${formatDate(startDate)} - ${formatEndDate(endDate)}`;
    const isClickable = Object.keys(row.data).some((key) => {
      const isDateRange = /\d{2}\/[A-Za-z]{3} - \d{2}\/[A-Za-z]{3}\/\d{4}/.test(
        key
      );
      return isDateRange && row.data[key] >= 1;
    });

    return (
      <Grid sx={{ display: "flex", alignItems: "center" }}>
        <Tooltip title="click to view">
          <IconButton
            onClick={() => {
              const data = {
                user: { username: row.data.username },
                startDate: startDate,
                endDate: endDate,
              };
              axiosInstance
                .put("/user/getRatingsByUser", data)
                .then((res) => {
                  if (res.data.length > 0) {
                    navigate("/home/ratings/UserScreenAppraisal", {
                      state: {
                        userRatings: res.data,
                        type: type,
                        username: row.data.username,
                      },
                    });
                    setLoad(false);
                  } else {
                    // const error = {
                    //   message: `No Ratings Found for the ${row.data.firstname} ${row.data.lastname}`,
                    // };
                    setLoad(false);
                    onError({
                      response: {
                        data: `No Ratings Found for the ${row.data.firstname} ${row.data.lastname}`,
                      },
                    });
                  }
                })
                .catch((err) => onError(err));
            }}
          >
            <VisibilityIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="click to give ratings">
          <Link
            sx={{
              cursor: "pointer",
            }}
            underline="hover"
            onClick={(e) => {
              // if (isClickable) {
              const data = {
                user: { username: row.data.username },
                startDate: startDate,
                endDate: endDate,
              };
              axiosInstance
                .put("/user/getRatingsByUser", data)
                .then((res) => {
                  if (res.data.length > 0) {
                    navigate("/home/ratings/UserAppraisalForm", {
                      state: {
                        fullname: `${row.data.firstname} ${row.data.lastname}`,
                        astId: row.data.associateId,
                        username: row.data.associateId,
                        project: row.data.projectTitles,
                        startDate: startDate,
                        endDate: endDate,
                      },
                    });
                    setLoad(false);
                  } else {
                    // const error = {
                    //   message: `No Ratings Found for the ${row.data.firstname} ${row.data.lastname}`,
                    // };
                    setLoad(false);
                    onError({
                      response: {
                        data: `No Ratings Found for the ${row.data.firstname} ${row.data.lastname}`,
                      },
                    });
                  }
                })
                .catch((err) => onError(err));
              // }
            }}
          >
            {row.data.firstname} {row.data.lastname}
          </Link>
        </Tooltip>
      </Grid>
    );
  };

  const ScoreCell = (row) => {
    const ratings = row.context?.ratingsMap || pastRatings;
    const ratingData = ratings?.[row?.data?.associateId];
    const dates = ratingData?.dates || [];
    const submittedByPM = ratingData?.submittedByPM || [];
    const ukScores = ratingData?.ukScores || [];

    // Find the last PM-submitted uk score (skip self-submitted-only entries)
    let ukScore = 0;
    for (let i = 0; i < dates.length; i++) {
      if (submittedByPM[i] === true && ukScores[i] > 0) {
        ukScore = ukScores[i];
        break;
      }
    }
    if (ukScore === 0 && ratingData?.latestGlobalUkScore > 0) {
      ukScore = ratingData.latestGlobalUkScore;
    }

    return (
      <Grid sx={{ display: "flex", mt: 1, justifyContent: "flex-end", alignItems: "center" }}>
        <Typography sx={{ textAlign: "right" }}>
          {ukScore > 0 ? ukScore : 0}
        </Typography>
      </Grid>
    );
  };

  const SubmissionBadgeCell = (row) => {
    const ratingData = pastRatings?.[row?.data?.associateId];
    const pmSubmitted = ratingData?.currentPeriodPmSubmitted === true;
    const userSubmitted = ratingData?.currentPeriodUserSubmitted === true;

    let label, baseColor, darkColor, textColor;
    if (pmSubmitted) {
      label = "PM Submitted"; baseColor = "#02a4a8"; darkColor = "#014d4e"; textColor = "#fff";
    } else if (userSubmitted) {
      label = "Self Submitted"; baseColor = "#ff9800"; darkColor = "#c65c00"; textColor = "#fff";
    } else {
      label = "Not Submitted"; baseColor = "#bdbdbd"; darkColor = "#757575"; textColor = "#fff";
    }

    return (
      <Grid sx={{ display: "flex", alignItems: "center", height: "100%" }}>
        <span style={{
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: "110px",
          height: "24px",
          borderRadius: "12px",
          background: `linear-gradient(160deg, ${baseColor} 0%, ${darkColor} 100%)`,
          boxShadow: `0 4px 8px ${darkColor}99, 0 1px 2px ${darkColor}cc, inset 0 1px 0 rgba(255,255,255,0.35), inset 0 -1px 0 rgba(0,0,0,0.2)`,
          border: `1px solid ${darkColor}`,
          overflow: "hidden",
          cursor: "default",
        }}>
          {/* gloss shine */}
          <span style={{
            position: "absolute",
            top: 0, left: 0, right: 0,
            height: "50%",
            borderRadius: "12px 12px 50% 50%",
            background: "linear-gradient(180deg, rgba(255,255,255,0.38) 0%, rgba(255,255,255,0.05) 100%)",
            pointerEvents: "none",
          }} />
          <span style={{
            position: "relative",
            fontSize: "10px",
            fontFamily: "Lucida Grande, sans-serif",
            fontWeight: "700",
            color: textColor,
            letterSpacing: "0.4px",
            textShadow: `0 1px 2px rgba(0,0,0,0.35)`,
            userSelect: "none",
          }}>
            {label}
          </span>
        </span>
      </Grid>
    );
  };

  const AIUsageCell = (params) => {
    const aiRaw = pastRatings?.[params?.data?.associateId]?.aiUsageData;
    let parsed = null;
    try { parsed = aiRaw ? JSON.parse(aiRaw) : null; } catch (e) { parsed = null; }
    if (!parsed || !parsed.isUsingAI) {
      return <Grid sx={{ display: "flex", alignItems: "center", height: "100%" }}><span style={{ color: "#aaa", fontSize: 13 }}>—</span></Grid>;
    }
    const isYes = parsed.isUsingAI === "yes";
    const baseColor = isYes ? "#00897b" : "#9e9e9e";
    const darkColor = isYes ? "#004d40" : "#616161";
    return (
      <Grid sx={{ display: "flex", alignItems: "center", height: "100%" }}>
        <span
          onClick={isYes ? () => setAiDialog({ open: true, data: parsed, name: `${params.data.firstname} ${params.data.lastname}` }) : undefined}
          style={{
            position: "relative", display: "inline-flex", alignItems: "center", justifyContent: "center",
            width: "80px", height: "24px", borderRadius: "12px",
            background: `linear-gradient(160deg, ${baseColor} 0%, ${darkColor} 100%)`,
            boxShadow: `0 4px 8px ${darkColor}99, inset 0 1px 0 rgba(255,255,255,0.35)`,
            border: `1px solid ${darkColor}`, overflow: "hidden",
            cursor: isYes ? "pointer" : "default",
          }}
        >
          <span style={{ position: "absolute", top: 0, left: 0, right: 0, height: "50%", borderRadius: "12px 12px 50% 50%", background: "linear-gradient(180deg, rgba(255,255,255,0.38) 0%, rgba(255,255,255,0.05) 100%)", pointerEvents: "none" }} />
          <span style={{ position: "relative", fontSize: "10px", fontFamily: "Lucida Grande, sans-serif", fontWeight: "700", color: "#fff", letterSpacing: "0.4px", textShadow: "0 1px 2px rgba(0,0,0,0.35)", userSelect: "none" }}>
            {isYes ? "Using AI" : "No AI"}
          </span>
        </span>
      </Grid>
    );
  };

  const getSubmissionLabelForDownload = (associateId, ratingsData) => {
    const ratingData = ratingsData?.[associateId];
    if (ratingData?.currentPeriodPmSubmitted === true) return "PM Submitted";
    if (ratingData?.currentPeriodUserSubmitted === true) return "Self Submitted";
    return "Not Submitted";
  };

  const handleDownloadReport = async () => {
    console.log("pdf downloading...");
    try {
      const res = await axiosInstance.post(
        `/user/getAllassociatesforRatings?project=${projectFromAppraisal}&sortBy=${sortBy}&tenantId=${tenantId}`,
        { startDate, endDate }
      );

      const astIds = res.data.map((user) => user.associateId);
      let pastRatings = {};

      if (astIds.length > 0) {
        const ratingsRes = await axiosInstance.put(
          `/user/get/past/ratings?endDate=${endDate}&managerId=${user.associateId}`,
          astIds
        );
        pastRatings = ratingsRes.data;
      }

      const filteredElements = [...res.data].sort((a, b) => (a.associateId || 0) - (b.associateId || 0));

      if (filteredElements.length > 0) {
        const pdf = new jsPDF({
          orientation: "landscape",
          unit: "mm",
          format: [420, 297],
        });
        pdf.setFont("helvetica", "normal");

        const logoUrl =
          "https://tse3.mm.bing.net/th?id=OIP.xrnfPsu-nIEVf0HzuyWt3AAAAA&pid=Api&P=0&h=180";
        pdf.addImage(logoUrl, 15, 10, 30, 30);
        pdf.setFontSize(18);
        pdf.text("All Associates Ratings Report", 120, 20);
        pdf.setFontSize(14);
        pdf.text(
          `For the period: ${moment(startDate).format(
            "DD-MMM-yyyy"
          )} to ${moment(endDate).format("DD-MMM-yyyy")}`,
          120,
          30
        );

        pdf.setLineWidth(0.5);
        pdf.line(10, 45, 400, 45);

        let userArr = [];
        let newObj = {};
        for (let i = 0; i < arr.length; i++) {
          if (i % 2 === 0) {
            newObj = {
              ...newObj,
              [arr[i].concat(" - ").concat(arr[i + 1])]: 0,
            };
          }
        }

        const isBiWeekly = datefilter === "Last Bi-Weekly";
        const formattedData = filteredElements.map((row) => {
          let userObj = {
            "Ast ID": row?.associateId || "",
            "Associate Name":
              row.firstname && row.lastname
                ? `${row.firstname} ${row.lastname}`
                : "",
            Projects: row.projectTitles || "",
            "UK Score": Math.floor(
              (pastRatings[row.associateId]?.finalRating || 0) * 180
            ),
            ...(isBiWeekly && { "Submission": getSubmissionLabelForDownload(row.associateId, pastRatings) }),
          };
          let changedNewObj = { ...newObj };
          if (row.userAppraisalsList.length !== 0) {
            row.userAppraisalsList.forEach((appraisal) => {
              userObj.Comments = appraisal?.comments || "";
              Object.keys(newObj).forEach((key) => {
                if (
                  key ===
                  moment(appraisal?.startDate, "YYYY,MM,DD")
                    .format("DD/MMM")
                    .concat(" - ")
                    .concat(
                      moment(appraisal?.endDate, "YYYY,MM,DD").format(
                        "DD/MMM/YYYY"
                      )
                    )
                ) {
                  changedNewObj[key] = parseFloat(
                    appraisal?.ratings.toFixed(2)
                  );
                }
              });
            });
          }
          return { ...userObj, ...changedNewObj };
        });

        const header = [
          "Ast ID",
          "Associate Name",
          "Projects",
          "UK Score",
          ...(isBiWeekly ? ["Submission"] : []),
          ...Object.keys(newObj),
        ];
        const userData = formattedData.map((val) =>
          header.map((h) => val[h] ?? "")
        );

        pdf.autoTable({
          head: [header],
          body: userData,
          startY: 50,
          styles: {
            fontSize: 10,
            cellPadding: 2,
            font: "helvetica",
            lineWidth: 0.1,
          },
          headStyles: {
            fillColor: "#008080",
            textColor: "#ffffff",
            fontStyle: "bold",
            fontSize: 11,
          },
          columnStyles: {
            0: { cellWidth: 15 },
            1: { cellWidth: 35 },
            2: { cellWidth: 35 },
            3: { cellWidth: 15 },
            4: { cellWidth: 15 },
          },
          margin: { top: 10, left: 10, right: 10 },
          tableWidth: "auto",
          didParseCell: function (data) {
            if (isBiWeekly && data.column.dataKey === "Submission" && data.section === "body") {
              const val = data.cell.raw;
              if (val === "PM Submitted") { data.cell.styles.fillColor = [1, 100, 102]; data.cell.styles.textColor = [255, 255, 255]; }
              else if (val === "Self Submitted") { data.cell.styles.fillColor = [245, 124, 0]; data.cell.styles.textColor = [255, 255, 255]; }
              else { data.cell.styles.fillColor = [158, 158, 158]; data.cell.styles.textColor = [255, 255, 255]; }
            }
          },
          didDrawPage: function (data) {
            pdf.setFontSize(12);
            pdf.text(
              "Generated on: " + moment().format("DD-MMM-YYYY HH:mm"),
              330,
              20
            );
          },
        });

        pdf.save(`AllAssociateRatings.pdf`);
      }
    } catch (err) {
      onError(err);
    }
  };

  const handleDownloadReportExcel = async () => {
    console.log("Excel Report...");
    try {
      const res = await axiosInstance.post(
        `/user/getAllassociatesforRatings?project=${projectFromAppraisal}&sortBy=${sortBy}&tenantId=${tenantId}`,
        { startDate, endDate }
      );

      const astIds = res.data.map((user) => user.associateId);
      let pastRatings = {};

      if (astIds.length > 0) {
        const ratingsRes = await axiosInstance.put(
          `/user/get/past/ratings?endDate=${endDate}&managerId=${user.associateId}`,
          astIds
        );
        pastRatings = ratingsRes.data;
      }

      const filteredElements = [...res.data].sort((a, b) => (a.associateId || 0) - (b.associateId || 0));

      const fileName = `All Associates Ratings Report.xlsx`;

      if (filteredElements.length > 0) {
        const isBiWeeklyExcel = datefilter === "Last Bi-Weekly";
        const dateRange = `${moment(startDate).format("DD/MM/YYYY")} to ${moment(endDate).format("DD/MM/YYYY")}`;
        const formattedData = filteredElements.map((row) => {
          const score = pastRatings[row.associateId]?.finalRating || 0;
          return {
            "Ast ID": row?.associateId || "",
            "Associate Name":
              row.firstname && row.lastname
                ? `${row.firstname} ${row.lastname}`
                : "",
            "Projects": row.projectTitles || "",
            "Date Range": dateRange,
            "Comments": "",
            "UK Score": Math.floor(score * 180),
            ...(isBiWeeklyExcel && { "Submission": getSubmissionLabelForDownload(row.associateId, pastRatings) }),
            "userAppraisalsList": row.userAppraisalsList || "",
          };
        });

        let userArr = [];
        let newObj = {};
        for (let i = 0; i < arr.length; i++) {
          if (i % 2 === 0) {
            newObj = {
              ...newObj,
              [arr[i].concat(" - ").concat(arr[i + 1])]: 0,
            };
          }
        }

        formattedData.forEach((data) => {
          let userObj = {};
          let comment = "";
          if (data["userAppraisalsList"].length !== 0) {
            let changedNewObj = { ...newObj };
            data["userAppraisalsList"].forEach((appraisal) => {
              comment = appraisal?.comments;
              Object.keys(newObj).forEach((key) => {
                if (
                  key ===
                  moment(appraisal?.startDate, "YYYY,MM,DD")
                    .format("DD/MMM")
                    .concat(" - ")
                    .concat(
                      moment(appraisal?.endDate, "YYYY,MM,DD").format("DD/MMM/YYYY")
                    )
                ) {
                  changedNewObj[key] = parseFloat(appraisal?.ratings.toFixed(2));
                }
              });
            });
            userObj = { ...data, ...changedNewObj, Comments: comment };
          } else {
            userObj = { ...data, ...newObj };
          }
          userArr.push(userObj);
        });

        const header = [
          "Ast ID",
          "Associate Name",
          "Projects",
          "Date Range",
          "Comments",
          "UK Score",
          ...(isBiWeeklyExcel ? ["Submission"] : []),
        ];
        const newHeader = isBiWeeklyExcel ? header : header.concat(Object.keys(newObj));

        const userData = userArr.map((val) => newHeader.map((h) => val[h] ?? ""));

        // Build styled worksheet using xlsx-js-style
        const submissionColIdx = isBiWeeklyExcel ? newHeader.indexOf("Submission") : -1;
        const submissionColors = {
          "PM Submitted":   { fgColor: { rgb: "016466" } },
          "Self Submitted": { fgColor: { rgb: "F57C00" } },
          "Not Submitted":  { fgColor: { rgb: "9E9E9E" } },
        };

        const headerStyle = {
          font: { bold: true, color: { rgb: "FFFFFF" }, sz: 11 },
          fill: { fgColor: { rgb: "008080" } },
          alignment: { horizontal: "center", vertical: "center", wrapText: true },
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
        const cellBorder = {
          top: { style: "thin", color: { rgb: "CCCCCC" } },
          bottom: { style: "thin", color: { rgb: "CCCCCC" } },
          left: { style: "thin", color: { rgb: "CCCCCC" } },
          right: { style: "thin", color: { rgb: "CCCCCC" } },
        };

        const wsData = [
          newHeader.map((h) => ({ v: h, t: "s", s: headerStyle })),
          ...userData.map((row, rIdx) =>
            row.map((cell, cIdx) => {
              const isSubmCol = cIdx === submissionColIdx;
              const fillColor = isSubmCol ? submissionColors[cell]?.fgColor?.rgb : null;
              return {
                v: cell ?? "",
                t: typeof cell === "number" ? "n" : "s",
                s: {
                  font: { sz: 10, color: isSubmCol && fillColor ? { rgb: "FFFFFF" } : { rgb: "000000" } },
                  fill: fillColor ? { fgColor: { rgb: fillColor } } : { fgColor: { rgb: rIdx % 2 === 0 ? "F5F5F5" : "FFFFFF" } },
                  alignment: { vertical: "center", horizontal: cIdx === 0 || typeof cell === "number" ? "right" : "left" },
                  border: cellBorder,
                },
              };
            })
          ),
        ];

        const ws = XLSXStyle.utils.aoa_to_sheet(wsData);

        // Column widths
        ws["!cols"] = newHeader.map((h) => {
          if (h === "Ast ID") return { wch: 8 };
          if (h === "Associate Name") return { wch: 28 };
          if (h === "Projects") return { wch: 30 };
          if (h === "Date Range") return { wch: 24 };
          if (h === "Comments") return { wch: 20 };
          if (h === "UK Score") return { wch: 10 };
          if (h === "Submission") return { wch: 16 };
          return { wch: 16 };
        });
        ws["!rows"] = [{ hpt: 22 }, ...userData.map(() => ({ hpt: 18 }))];

        const wb = XLSXStyle.utils.book_new();
        XLSXStyle.utils.book_append_sheet(wb, ws, "data");
        const excelBuffer = XLSXStyle.write(wb, { bookType: "xlsx", type: "array" });

        const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const data = new Blob([excelBuffer], { type: fileType });
        saveAs(data, fileName);
      }
    } catch (err) {
      onError(err);
    }
  };

  const PastRatingsCell = (row) => {
    const ratings = pastRatings?.[row?.data?.associateId] ?? [];
    return (
      <PastRatingsCustomCell
        user={user}
        ratings={ratings}
        astId={row?.data?.associateId}
        project={row?.data?.projectTitles}
      />
    );
  };
  // const PastRatingScoreCell = (row) => {
  //     const associateId = row?.data?.associateId;
  //     const score = pastRatings?.[associateId]?.score || 0;

  //     return (
  //         <Grid sx={{ display: 'flex', mt: 1, alignItems: 'center' }}>
  //             <Typography>{score}</Typography>
  //         </Grid>
  //     );
  // };

  const getRatingAge = (row) => {
    if (pastRatings?.[row?.data?.associateId]?.score === 0) {
      return <div style={{ color: "gray" }}>No rating available</div>;
    }
    const ratingDate =
      pastRatings?.[row?.data?.associateId]?.dates?.[0]?.endDate;
    if (!ratingDate) {
      return <div style={{ color: "gray" }}>No rating available</div>;
    }
    const rating = new Date(ratingDate);
    const currentDate = new Date();
    const timeDifference = currentDate - rating;
    const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const weeksDifference = Math.floor(daysDifference / 7);
    const color = weeksDifference > 2 ? "gray" : "black";
    if (daysDifference < 7) {
      return (
        <div style={{ color }}>
          {`${daysDifference} day${daysDifference > 1 ? "s" : ""} ago`}
        </div>
      );
    } else {
      return (
        <div style={{ color }}>
          {`${weeksDifference} week${weeksDifference > 1 ? "s" : ""} ago`}
        </div>
      );
    }
  };

  const getRatingAgeCount = (row) => {
    if (pastRatings?.[row?.data?.associateId]?.score === 0) {
      return 0;
    }
    const ratingDate =
      pastRatings?.[row?.data?.associateId]?.dates?.[0]?.endDate;
    const rating = new Date(ratingDate);
    const currentDate = new Date();
    const timeDifference = currentDate - rating;
    const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    return daysDifference;
  };

  const colDefs = [
    {
      field: "associateId",
      headerName: "Ast ID",
      cellStyle: { textAlign: "right" },
      // width: 200,
      flex: 1,
    },
    {
      field: "fullname",
      headerName: "Associate Name",
      cellRenderer: CustomNameComponent,
      valueGetter: (params) => {
        return `${params.data.firstname} ${params.data.lastname}`;
      },
      // width: 200,
      flex: 1,
    },
    {
      field: "projectTitles",
      headerName: "Project",
      flex: 1,
      valueGetter: (params) => {
        const pt = params.data?.projectTitles;
        if (!pt) return "";
        return Array.isArray(pt) ? pt.join(", ") : pt;
      },
    },
    {
      headerName: "UK Score",
      cellRenderer: ScoreCell,
      flex: 1,
      valueGetter: (params) => {
        const ratingData = pastRatings?.[params?.data?.associateId];
        const submittedByPM = ratingData?.submittedByPM || [];
        const ukScores = ratingData?.ukScores || [];
        for (let i = 0; i < submittedByPM.length; i++) {
          if (submittedByPM[i] === true && ukScores[i] > 0) return ukScores[i];
        }
        return 0;
      },
      cellStyle: { textAlign: "right" },
    },
    ...(currentDateFilter === "Last Bi-Weekly" ? [{
      headerName: "Submission",
      cellRenderer: SubmissionBadgeCell,
      flex: 1,
      filter: "agSetColumnFilter",
      filterParams: {
        values: ["PM Submitted", "Self Submitted", "Not Submitted"],
      },
      valueGetter: (params) => {
        const ratingData = pastRatings?.[params?.data?.associateId];
        const dates = ratingData?.dates || [];
        const submittedByPM = ratingData?.submittedByPM || [];
        const submittedByUser = ratingData?.submittedByUser || [];
        const idx = dates.findIndex(
          (d) => moment(d.endDate).format("YYYY-MM-DD") === endDate
        );
        if (idx === -1 || (submittedByPM[idx] !== true && submittedByUser[idx] !== true)) return "Not Submitted";
        if (submittedByPM[idx] === true) return "PM Submitted";
        return "Self Submitted";
      },
    }, {
      headerName: "AI Usage",
      cellRenderer: AIUsageCell,
      flex: 1,
    }] : []),
    {
      headerName: "PERF Ratings",
      cellRenderer: PastRatingsCell,
      flex: 1,
      cellStyle: { textAlign: "right" },
    },

    {
      headerName: "Time Since Rated",
      cellRenderer: getRatingAge,
      valueGetter: (params) => {
        return getRatingAgeCount(params);
      },
      flex: 1,
    },
  ];

  if (datefilter === "Last 3 months") {
    let newObj = {};
    for (let i = 0; i < arr.length; i++) {
      if (i % 2 == 0) {
        colDefs.push({
          field: arr[i].concat(" - ").concat(arr[i + 1]),
          flex: 1,
        });
        newObj = { ...newObj, [arr[i].concat(" - ").concat(arr[i + 1])]: 0 };
      }
    }
  }

  const displayAdd = true;

  const handleDownloadReportTwo = async (mode = "all") => {
    try {
    const [associatesRes, ratingsStatusRes] = await Promise.all([
      axiosInstance.post(
        `/user/getAllassociatesforRatings?project=${projectFromAppraisal}&sortBy=${sortBy}&tenantId=${tenantId}`,
        { startDate, endDate }
      ),
      axiosInstance.put(
        `/user/getAllAssociateRatings?startDate=${startDate}&endDate=${endDate}&tenantId=${tenantId}`
      )
    ]);

    // Build a lookup for associate metadata (project, PM) keyed by associateId
    const associateMap = {};
    for (const row of associatesRes.data) {
      associateMap[row.associateId] = row;
    }


    const resolveUkScore = (item) => {
      const resolved = item.projectManagerSubmission && item.ukScore > 0 ? item.ukScore : (item.lastPmUkScore || 0);
      return resolved;
    };

    let data;
    if (datefilter === "Last Bi-Weekly") {
      data = ratingsStatusRes.data
        .filter((item) => {
          const itemStart = moment(item.startDate, ["DD-MMM-YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");
          const itemEnd = moment(item.endDate, ["DD-MMM-YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");
          return itemStart === startDate && itemEnd === endDate && associateMap[item.associateId];
        })
        .map((item) => {
          const assoc = associateMap[item.associateId] || {};
          return {
            associateId: item.associateId,
            fullname: item.fullname || (assoc.firstname && assoc.lastname ? `${assoc.firstname} ${assoc.lastname}` : ""),
            projectTitles: item.projectTitles || item.project || assoc.projectTitles || "",
            projectManagerName: item.projectManagerName || item.projectManager?.fullname || "",
            ukScore: resolveUkScore(item),
            userSideSubmission: item.userSideSubmission || false,
            projectManagerSubmission: item.projectManagerSubmission || false,
            startDate,
            endDate,
          };
        });
    } else {
      data = ratingsStatusRes.data.filter((item) => associateMap[item.associateId]).map((item) => {
        const assoc = associateMap[item.associateId] || {};
        const itemStart = moment(item.startDate, ["DD-MMM-YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");
        const itemEnd = moment(item.endDate, ["DD-MMM-YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");
        return {
          associateId: item.associateId,
          fullname: item.fullname || (assoc.firstname && assoc.lastname ? `${assoc.firstname} ${assoc.lastname}` : ""),
          projectTitles: item.projectTitles || item.project || assoc.projectTitles || "",
          projectManagerName: item.projectManagerName || item.projectManager?.fullname || "",
          ukScore: resolveUkScore(item),
          userSideSubmission: item.userSideSubmission || false,
          projectManagerSubmission: item.projectManagerSubmission || false,
          startDate: itemStart,
          endDate: itemEnd,
        };
      });
    }

    if (mode === "latest") {
      const latestMap = {};
      for (const item of data) {
        const existing = latestMap[item.associateId];
        if (!existing || item.endDate > existing.endDate ||
            (item.endDate === existing.endDate && item.projectManagerSubmission && !existing.projectManagerSubmission) ||
            (item.endDate === existing.endDate && item.projectManagerSubmission === existing.projectManagerSubmission && item.ukScore > existing.ukScore)) {
          latestMap[item.associateId] = item;
        }
      }
      data = Object.values(latestMap);
    }

    if (mode === "average") {
      const avgMap = {};
      for (const item of data) {
        const id = item.associateId;
        if (!avgMap[id]) {
          avgMap[id] = { ...item, _ukScores: [], _pmNames: new Set(), _projects: new Set(), startDate, endDate };
        }
        if (item.ukScore > 0) avgMap[id]._ukScores.push(item.ukScore);
        if (item.projectManagerName) avgMap[id]._pmNames.add(item.projectManagerName);
        if (item.projectTitles) avgMap[id]._projects.add(item.projectTitles);
      }
      data = Object.values(avgMap).map((entry) => {
        const avg = entry._ukScores.length > 0
          ? Math.round(entry._ukScores.reduce((s, v) => s + v, 0) / entry._ukScores.length)
          : 0;
        return {
          ...entry,
          ukScore: avg,
          projectManagerName: [...entry._pmNames].join(", "),
          projectTitles: [...entry._projects].join(", "),
        };
      });
    }

    const formattedData = data.map((item) => ({
      "Ast ID": item.associateId,
      "Associate Name": item.fullname,
      "Project": item.projectTitles || "N/A",
      "Project Manager": item.projectManagerName,
      "Date Range": `${moment(item.startDate).format("DD/MM/YYYY")} to ${moment(item.endDate).format("DD/MM/YYYY")}`,
      "UK Score": item.ukScore,
      "Self Rating": mode === "average" ? "-" : (item.userSideSubmission ? "Yes" : "No"),
      "PM Final Rating": mode === "average" ? "-" : (item.projectManagerSubmission ? "Yes" : "No"),
      "Combined Status": mode === "average" ? "-" : (item.userSideSubmission && item.projectManagerSubmission ? "Yes" : "No"),
      "_sortStart": item.startDate,
      "_carriedUkScore": mode !== "average" && item.projectManagerSubmission && item.ukScore > 0,
    }));
    // Sort by Ast ID, then chronologically by actual start date (YYYY-MM-DD sorts correctly)
    formattedData.sort((a, b) => a["Ast ID"] - b["Ast ID"] || a["_sortStart"].localeCompare(b["_sortStart"]));

    // Only highlight the latest PM-submitted row per associate
    const lastPmIdxMap = {};
    formattedData.forEach((row, idx) => {
      if (row["_carriedUkScore"]) lastPmIdxMap[row["Ast ID"]] = idx;
    });
    formattedData.forEach((row, idx) => {
      row["_carriedUkScore"] = row["_carriedUkScore"] && idx === lastPmIdxMap[row["Ast ID"]];
    });

    await exportBiWeeklyRatingsExcel({ formattedData, mode, startDate, endDate });
    } catch (err) { console.error("PM handleDownloadReportTwo error:", err); }
  };

  return (
    <>
      <GenericTable
        type={type}
        setTenantId={setTenantId}
        Companies={props.Companies}
        setUsers={setusers}
        colDefs={colDefs}
        gridKey={`grid-${Object.keys(pastRatings).length}-${currentDateFilter}-${endDate}`}
        gridContext={{ ratingsMap: pastRatings, currentDateFilter, endDate }}
        elements={users}
        filteredElements={filteredusers}
        setFilteredElements={setFilteredusers}
        setProjectFromAppraisal={setProjectFromAppraisal}
        projectFromAppraisal={projectFromAppraisal}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        page={page}
        setPage={setPage}
        setDateFilter={(val) => { setDateFilter(val); setCurrentDateFilter(val); }}
        setRatingsEndDate={setRatingsEndDate}
        setProject={setProject}
        totalPages={totalPages}
        snackbarOpen={snackbarOpen}
        setSnackbarOpen={setSnackbarOpen}
        errorMessage={errorMessage}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        setStartDateError={setStartDateError}
        setEndDateError={setEndDateError}
        minDate={true}
        loading={loading}
        isDrawerOpen={isDrawerOpen}
        setIsDrawerOpen={setIsDrawerOpen}
        handleDownloadReport={handleDownloadReport}
        handleDownloadReportExcel={handleDownloadReportExcel}
        handleDownloadReportTwo={handleDownloadReportTwo}
        datefilter={datefilter}
        associateStatus={associateStatus}
        setAssociateStatus={setAssociateStatus}
        displayAdd={false}
        displayHeader={displayAdd}
      />
      <Dialog open={aiDialog.open} onClose={() => setAiDialog({ open: false, data: null, name: "" })} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: "bold" }}>{aiDialog.name} — AI Usage</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 1 }}><b>Tools used:</b> {[aiDialog.data?.tool, aiDialog.data?.otherTool ? `(${aiDialog.data.otherTool})` : ""].filter(Boolean).join(" ")}</Typography>
          <Typography sx={{ mb: 1 }}><b>Where &amp; how:</b> {aiDialog.data?.howAndWhere}</Typography>
          <Typography><b>Result / outcome:</b> {aiDialog.data?.result}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAiDialog({ open: false, data: null, name: "" })} variant="contained" sx={{ background: "#00897b" }}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ProjectManagerAppraisal;
